import { PlusOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FortnightlyTable } from '../../components/Fortnightly/FortnightlyTable';
import { TitleBreadcrumbs } from '../../uiComponents/TitleBreadcrumbs';

export const FortnightlyRows = () => {
  const navigate = useNavigate();
  return (
    <Card title={<TitleBreadcrumbs />} bordered={true} className="gx-card">
      <Button
        type="primary"
        htmlType="submit"
        onClick={() => {
          navigate('/dashboard/catorcenas/crear');
        }}
      >
        <PlusOutlined />
        Nuevo
      </Button>

      <FortnightlyTable />
    </Card>
  );
};
